<script setup lang="ts">
import { useAdmissions } from '~/composables/useAdmissions'
import type { TuitionFee } from '~/composables/useAdmissions'

const props = defineProps<{
  fees?: TuitionFee[]
  registrationFee?: string
}>()

// If no fees provided via props, fetch from API
const { getAdmissionsConfig } = useAdmissions()
const admissionsData = props.fees ? null : await getAdmissionsConfig()

const displayFees = computed(() => props.fees || admissionsData?.fees || [])
const displayRegistrationFee = computed(() => props.registrationFee || admissionsData?.registrationFee || '')
</script>

<template>
  <section class="py-20 bg-oxo-card-bg/5 border-y border-oxo-border">
    <div class="container mx-auto px-6">
      <div class="flex flex-col lg:flex-row gap-16 items-center">
        <div class="lg:w-1/2">
          <UiSectionHeader 
            align="left"
            titlePrefix="Frais de"
            titleHighlight="Scolarité"
            subtitle="Investissez dans votre avenir"
          />
          <p class="text-lg text-foreground-dim mb-8">
            Nous prônons la transparence totale sur nos tarifs. Pas de frais cachés, une formation d'excellence accessible.
          </p>
          <div v-if="displayRegistrationFee" class="p-6 rounded-2xl bg-oxo-yellow/10 border border-oxo-yellow/20 flex items-center gap-4">
            <div class="w-12 h-12 rounded-full bg-oxo-yellow/20 flex items-center justify-center text-oxo-yellow text-xl">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
            </div>
            <div>
              <p class="text-sm font-bold text-foreground">Droits d'inscription</p>
              <p class="text-foreground dark:text-oxo-yellow font-black">{{ displayRegistrationFee }}</p>
            </div>
          </div>
        </div>

        <div class="lg:w-1/2 w-full">
          <div class="grid gap-6">
            <div v-for="fee in displayFees" :key="fee.year" 
              class="flex items-center justify-between p-8 rounded-3xl bg-background border border-oxo-border"
            >
              <div>
                <h3 class="font-bold text-lg text-foreground mb-1">{{ fee.year }}</h3>
                <p class="text-sm text-foreground-dim">{{ fee.details }}</p>
              </div>
              <div class="text-right">
                <div class="text-2xl font-black text-oxo-red">{{ fee.price }}</div>
                <div class="text-[10px] text-foreground-dim uppercase tracking-widest">Par an</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
